import { render } from "./CustomImage.vue?vue&type=template&id=06b0a2a2"
import script from "./CustomImage.vue?vue&type=script&lang=js"
export * from "./CustomImage.vue?vue&type=script&lang=js"
script.render = render

export default script